import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type Props = {
  // Show the icon when true; render nothing when false so call sites can
  // unconditionally mount the component.
  show: boolean;
  message: string;
  id: string;
  // Orange (warning) by default; red (error) when explicitly set.
  severity?: "warning" | "error";
};

export const InvoiceFieldWarning: React.FC<Props> = ({
  show,
  message,
  id,
  severity = "warning",
}) => {
  if (!show) return null;
  const color = severity === "error" ? "red" : "orange";
  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={`invoice-field-warning-${id}`}>{message}</Tooltip>}
    >
      <FontAwesomeIcon
        className="ml-2"
        color={color}
        icon="exclamation-triangle"
        style={{ cursor: "help" }}
        data-cy={`invoice-field-warning-${id}`}
      />
    </OverlayTrigger>
  );
};

export default InvoiceFieldWarning;
